import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { getPrintfulOrderStatus } from '../apiClient';
import { loadStripe } from '@stripe/stripe-js';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the Stripe object on every render.
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const PaymentSuccessPage = () => {
  const location = useLocation();
  const { paymentIntentId, orderId } = location.state || {};
  const [orderStatus, setOrderStatus] = useState('Fetching order status...');

  useEffect(() => {
    const fetchOrderStatus = async () => {
      if (orderId) {
        try {
          const response = await getPrintfulOrderStatus(parseInt(orderId, 10));
          setOrderStatus(`Order Status: ${response.fulfillment_status || 'N/A'}`);
        } catch (error) {
          console.error('Error fetching order status:', error);
          setOrderStatus('Failed to fetch order status.');
        }
      } else {
        setOrderStatus('Order ID not available.');
      }
    };

    fetchOrderStatus();
  }, [orderId]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="bg-card p-8 rounded-lg shadow-lg w-full max-w-md text-center">
        <h2 className="text-2xl font-bold mb-4 text-green-600">Payment Successful!</h2>
        <p className="mb-4">Your payment has been processed successfully.</p>
        {paymentIntentId && (
          <p className="mb-4 text-sm text-gray-600">Payment Intent ID: {paymentIntentId}</p>
        )}
        <p className="mb-4 text-sm text-gray-600">{orderStatus}</p>
        <p className="mb-6">Thank you for your purchase!</p>
        <Link to="/" className="bg-primary hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md">
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
